'use client';

import { SvgShare2 } from '@common/icon';
import { cn } from '@core/utils';
import dayjs from 'dayjs';

import { CustomLink } from '@/app/_components/CustomLink';
import { DONATION_ROUTES } from '@/constants';
import { useGlobalStore } from '@/stores/GlobalStore';

import { useRemainingTime } from './_hooks/useRemainingTime';
import { padNumber } from './_utils/padNumber';

const END_DATE = dayjs('2025-11-30T23:59:59');

export const Footer = () => {
  const setShareLink = useGlobalStore((state) => state.setShareLink);
  const {
    leftMinutes,
    leftSeconds,
    leftMilliseconds,
    isExpired,
    leftDays,
    leftHours,
  } = useRemainingTime({ endDate: END_DATE });

  return (
    <div className="sticky bottom-0 z-10 mt-auto flex w-full flex-col">
      {!isExpired ? (
        <div className="gap-10 bg-Gray-black/60 px-20 py-12 backdrop-blur-sm flex-center">
          <span className="inline-flex min-h-30 items-center whitespace-nowrap rounded-r-pill bg-R-500 px-14 font-700 text-Gray-white typo-body4">
            마감까지
          </span>

          <p className={cn('font-500 text-Gray-white')}>
            <span>{padNumber(leftDays)}</span>일{' '}
            <span>{padNumber(leftHours)}</span>시간{' '}
            <span>{padNumber(leftMinutes)}</span>분{' '}
            <span>{padNumber(leftSeconds)}</span>초{' '}
            <span>{padNumber(Math.floor(leftMilliseconds / 10))}</span>
          </p>
        </div>
      ) : null}
      <div className="flex items-center gap-8 bg-Gray-black/50 px-20 py-12 backdrop-blur-md">
        <CustomLink
          className={cn(
            'h-56 w-full rounded-small bg-O-500 font-700 text-Gray-white flex-center typo-body3',
            {
              'bg-Gray-700 text-Gray-300': isExpired,
            },
          )}
          href={`${DONATION_ROUTES.HOME.pathname}?utm_source=wello&utm_medium=event&utm_campaign=event_1106&utm_content=donation_251106`}
          aria-label="고향사랑기부 홈 화면으로 이동"
          onClick={(e) => {
            if (isExpired) {
              e.preventDefault();

              return;
            }
          }}
        >
          {isExpired ? '마감' : '지금 기부하기'}
        </CustomLink>
        <button
          type="button"
          aria-label="공유하기"
          className="size-fit p-0"
          onClick={() => {
            setShareLink(location.href);
          }}
        >
          <SvgShare2 className="size-20 text-Gray-white" />
        </button>
      </div>
    </div>
  );
};
